import { ArticleSectionType } from "../../../../__generated__/api";
import { AttachmentBlock } from "./ArticleAttachment";
import { HtmlBlock } from "./Html";
import { SearchBlock } from "./Search";

const BLOCK_MAP = {
    [ArticleSectionType.Image]: AttachmentBlock,
    [ArticleSectionType.Video]: AttachmentBlock,
    [ArticleSectionType.Code]: HtmlBlock,
    [ArticleSectionType.Html]: HtmlBlock,
    [ArticleSectionType.Note]: HtmlBlock,
    [ArticleSectionType.Subtitle]: HtmlBlock,
    [ArticleSectionType.Title]: HtmlBlock,
    [ArticleSectionType.Search]: SearchBlock,
};

export default BLOCK_MAP;
